export default "__VITE_ASSET__DCaa15vd__"